<div class="page tracking history">
  <app-left-report [visibleComponents]="'objects'" [showDeviceMenu]="false"></app-left-report>

  <div class="vert_collapser" id="vert_collapser" onclick="collapseTrack()">
    <span><i></i></span>
  </div>

  <div class="righttrack">
    <div class="bottomright" id="bottomright">
      <div class="navblock">
        <div></div>
        <div class="inputgroup">
          <input class="dtpickerupleft" type="text" value="">
        </div>
        <button id="setintervalbtn" class="btn_blue">{{'Apply'|translate }}</button>
      </div>
      <div class="rightreport">
        <div class="tablewrap resizetable">
          <div class="table" id="maintable_print">
            <table>
              <tr><th id="reporttitle" colspan="5"></th></tr>
            </table>
            <div class="reportinfo">
              <div id="maintable" class="resizetable"></div>
              <div class="tablegraphics" id="trendtag"></div>
              <app-trend-list></app-trend-list>
            </div>
          </div>
          <app-pagination [viewmode]="'print excel reports'" [printElementID]="'maintable_print'"></app-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
